import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34; // 00:17:34

function pad(value: number) {
  return String(value).padStart(2, '0');
}
export function Countdown() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: pad(hours),
    label: 'HOURS'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEC'
  }];
  return <div className="w-full" data-id="element-18" data-mp="373b7s5toa7ew">
      <p className="mb-3 text-center text-[11px] font-bold uppercase tracking-[0.18em] text-teal-300" data-id="element-19" data-mp="374mas3fanb4y">
        ⏳ This launch offer expires in
      </p>
      <div className="flex items-stretch justify-center gap-2" role="timer" aria-live="off" aria-label={`Offer expires in ${pad(hours)} hours ${pad(minutes)} minutes ${pad(seconds)} seconds`} data-id="element-20" data-mp="15a4yy98h7tej">
        {blocks.map(block => <div key={block.label} className="flex min-w-[72px] flex-1 flex-col items-center rounded-xl border border-white/10 bg-ink-950/80 px-2 py-2.5 sm:min-w-[86px] sm:flex-none" data-id="element-21" data-mp="17rhpmytkuiyn">
            <span className="font-display text-3xl font-bold tabular-nums text-white sm:text-4xl" data-id="element-22" data-mp="f1iz0yzqidrv">
              {block.value}
            </span>
            <span className="mt-0.5 text-[10px] font-bold uppercase tracking-[0.14em] text-white/45" data-id="element-23" data-mp="a5c21vpbgcm2">
              {block.label}
            </span>
          </div>)}
      </div>
    </div>;
}